import { PortableText } from 'next-sanity'

import { Divider } from 'src/components/Divider/Divider'
import { Headline } from 'src/components/Headline/Headline'
import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'

import styles from './BrandValues.module.scss'

import type { PortableTextComponents } from 'next-sanity'
import type { SanityTextBlock } from 'src/types/HomepageContent'

interface BrandValueCardProps {
  title: string
  text: SanityTextBlock[]
}

const createPortableTextComponents = (): PortableTextComponents => ({
  block: {
    normal: ({ children }) => (
      <Text variant="p" className={styles.text}>
        {children}
      </Text>
    ),
    h2: ({ children }) => <h2 className="h5">{children}</h2>,
    h3: ({ children }) => <h3 className="h5">{children}</h3>,
    h4: ({ children }) => <h4 className="h5">{children}</h4>,
  },
  marks: {
    link: ({ children, value }) => (
      <Link
        href={value.href}
        inverted
        target={value.openInNewTab ? '_blank' : undefined}
        rel={value.openInNewTab ? 'noopener noreferrer' : undefined}
      >
        {children}
      </Link>
    ),
  },
})

export const BrandValueCard = ({ title, text }: BrandValueCardProps) => {
  const components = createPortableTextComponents()

  return (
    <div className={styles.card}>
      <Divider bold />
      <Headline variant="h3" className={styles.title}>
        {title}
      </Headline>
      <PortableText value={text} components={components} />
    </div>
  )
}
